/* eslint-disable max-len */
import { GetIAMAvailableModulesRequest } from '@1po/1po-bff-fe-spec/generated/catalog/available_modules/requerst/GetIAMAvailableModulesRequest';
import { GetIAMAvailableModulesResponse } from '@1po/1po-bff-fe-spec/generated/catalog/available_modules/response/GetIAMAvailableModulesResponse';
import { put, takeEvery } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import { getLastVehicleDetail } from 'domains/catalog/Catalog.store';
import { sendIAMAvailableModulesRequest } from 'domains/catalog/CatalogIam.api';
import * as actions from 'domains/catalog/CatalogIam.store';
import { setAvailableModules, setAvailableModulesStatus } from 'domains/catalog/CatalogIam.store';
import { getUserContext } from 'domains/user';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { LOADING, NOT_FOUND, sagaGuard, select } from 'utils';

export function* fetchIAMAvailableModulesRequestSaga(): SagaIterator {
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const userContext = yield* select(getUserContext);
  if (!vehicleDetail) {
    yield put(setAvailableModulesStatus({ status: NOT_FOUND }));
    return;
  }

  if (!vehicleDetail?.iamVehicle?.versionCode) {
    yield put(setAvailableModulesStatus({ status: NOT_FOUND }));
    return;
  }

  const request: GetIAMAvailableModulesRequest = {
    vehicleContext: {
      vehicleKey: vehicleDetail.vehicleKey,
      versionCode: vehicleDetail.iamVehicle.versionCode,
      vehicleCountryCode: vehicleDetail?.country ?? userContext.r1Country,
    },
    userContext,
  };
  yield put(setAvailableModulesStatus({ status: LOADING }));

  yield put(sendIAMAvailableModulesRequest(request));
}

export function* fetchIAMAvailableModulesResponseSaga(
  action: WsResponse<GetIAMAvailableModulesResponse>,
): SagaIterator {
  yield put(setAvailableModules(action.payload));
}

export function* IamModulesSagas(): SagaIterator {
  yield takeEvery(actions.fetchIAMAvailableModulesRequestSaga.type, sagaGuard(fetchIAMAvailableModulesRequestSaga));
  yield takeEvery(actions.fetchIAMAvailableModulesResponseSaga.type, sagaGuard(fetchIAMAvailableModulesResponseSaga));
}
